<template>
    <div>
            <h3 class="primary--text d-block mb-2" style="width: 100%;">Reajustes</h3>
            <v-data-table
                :headers="headers"
                :items="reajustes"
                item-key="id"
                class="primary--text az-table-list pb-2"
            >
                <template slot="headerCell" slot-scope="props">
                    <td v-bind="props.header" class="text-xs-left px-0" style="width: 20%;"> {{ props.header.text }}</td>
                </template>

                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.ano }}</td>
                    <td class="text-xs-left">{{ props.item.ano - 1}}</td>
                    <td class="text-xs-left">
                        <span :class="mostarCampoParaEdicao(props.item) ? 'red--text' : ''">
                            {{ props.item.percentualReajuste | cdCurrency('', 2) }}%
                        </span>
                        <div class="d-inline-flex mx-2 campoMonetarioEdicao" style="align-items: center;"
                             v-if="mostarCampoParaEdicao(props.item)">
                            <campo-monetario
                                             key="novoPercentualReajuste"
                                             ref="novoPercentualReajuste"
                                             name="Novo Perc. Reajuste"
                                             v-model="novoPercentualReajuste"
                                             placeholder="Novo % de Reajuste"
                                             autofocus
                                             @blur="(valor) => novoPercentualReajuste = valor"
                                             :maxLength="5"
                                             suffix=" %"
                                             prefix=""
                                             :required="true"
                                             :precision="2"
                                             v-validate="'required|'"
                            />
                            <div class="mt-3">
                                <v-tooltip top v-if="props.item.id === ultimoReajusteId">
                                    <template v-slot:activator="{on, attrs}">
                                        <v-btn v-on="on" v-bind="attrs" icon color="primary" flat
                                               @click.stop="salvarNovoPercentualReajuste(props.item)">
                                            <v-icon> check </v-icon>
                                        </v-btn>
                                    </template>
                                    Salvar
                                </v-tooltip>
                                <v-tooltip top v-if="props.item.id === ultimoReajusteId">
                                    <template v-slot:activator="{on, attrs}">
                                        <v-btn v-on="on" v-bind="attrs" icon color="red" flat
                                               @click.stop="cancelarEdicao">
                                            <v-icon> close </v-icon>
                                        </v-btn>
                                    </template>
                                    Cancelar
                                </v-tooltip>
                            </div>
                        </div>

                    </td>
                    <td class="text-xs-left">{{ props.item.valorBase | cdCurrency('R$ ', 2) }}</td>
                    <td class="text-xs-left">{{ props.item.indicador }}</td>
                    <td class="text-xs-left">{{ props.item.valorAtualizado | cdCurrency('R$ ', 2) }}</td>
                    <td class="text-xs-left">
                        <div v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'">
                            <v-tooltip top>
                                <template v-slot:activator="{on, attrs}">
                                    <v-btn v-on="on" v-bind="attrs" icon color="primary" flat
                                           :disabled="props.item.id !== ultimoReajusteId"
                                           @click.stop="habilitarModoEdicao">
                                        <v-icon> drive_file_rename_outline </v-icon>
                                    </v-btn>
                                </template>
                                Editar Reajuste
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{on, attrs}">
                                    <v-btn v-on="on" v-bind="attrs" icon color="red" flat
                                           :disabled="props.item.id !== ultimoReajusteId"
                                           @click.stop="tratarRemocao(props.item)">
                                        <v-icon> delete_outline </v-icon>
                                    </v-btn>
                                </template>
                                Remover Reajuste
                            </v-tooltip>
                        </div>
                    </td>
                </template>
            </v-data-table>
        <modal-excluir-reajuste :deveMostarModalExlusao="deveMostarModalExlusao"
                                @cancelar="processarEventoCancelar"
                                @confirmar="processarEventoConfirmar"/>
    </div>
</template>

<script>

import ModalExcluirReajuste from './ModalExcluirReajuste'

export default {
    name: 'HistoricoReajusteIndicePreco',
    components: {ModalExcluirReajuste},
    inject: ['$validator'],
    props: ['reajustes'],
    data: () => {
        return {
            mostarCampoEdicao: false,
            novoPercentualReajuste: null,
            deveMostarModalExlusao: false,
            reajusteEdicao: {},
            headers: [
                { text: 'Ano Base', value: 'anoBase', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Ano Indicador', value: 'anoIndicador', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: '% de Reajuste', value: 'percentualReajuste', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Valor Base', value: 'valorBase', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Indicador', value: 'indicador', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Valor Atualizado', value: 'valorAtualizado', class: 'primary--text font-weight-black', height: '50px', sortable: false },
                { text: 'Ações', value: 'acoes', class: 'primary--text font-weight-black', height: '50px', sortable: false }
            ]
        }
    },
    computed: {
        ultimoReajusteId(){
            if(this.reajustes.length <= 0) return 0
            return this.reajustes[0].id
        }
    },
    methods: {
        mostarCampoParaEdicao(reajuste){
            return (reajuste.id === this.ultimoReajusteId) && this.mostarCampoEdicao
        },
        cancelarEdicao(){
            this.mostarCampoEdicao = false
            this.novoPercentualReajuste = null
            this.$validator.reset()
        },
        async habilitarModoEdicao() {
            this.mostarCampoEdicao = true
            let inputEdicao = null

            const intervalo = setInterval(() => {
                if(inputEdicao === null) {
                    inputEdicao = document.querySelector('.campoMonetarioEdicao div input')
                    if (inputEdicao) inputEdicao.focus()
                }else{
                    clearInterval(intervalo)
                }
            }, 500)
        },
        async salvarNovoPercentualReajuste(reajuste) {
            const estaValidado = await this.$validator.validateAll()

            if (!estaValidado || this.novoPercentualReajuste < 0)
                throw new Error('Preencha novo percentual reajuste')

            const dadosEdicao = {
                id: reajuste.id,
                modalidadeId: reajuste.modalidadeId,
                percentualReajuste: this.novoPercentualReajuste
            }

            this.$emit('eventoSalvarNovoPercReajuste', dadosEdicao)
            this.mostrarNotificacaoSucessoDefault()
            this.cancelarEdicao()
        },
        tratarRemocao(reajuste){
            this.deveMostarModalExlusao = true
            this.reajusteEdicao = reajuste
        },
        processarEventoCancelar(){
            this.deveMostarModalExlusao = false
            this.reajusteEdicao = {}
        },
        processarEventoConfirmar(){
            this.$emit('eventoRemoverReajuste', { ...this.reajusteEdicao })
            this.processarEventoCancelar()
        }
    }
}
</script>

<style scoped lang="stylus">
    @media (max-width 720px)
        td
            text-align left

        td:nth-of-type(1):before
            content "Ano Base:"
            color var(--v-primary-base)

        td:nth-of-type(2):before
            content "Ano Indicador:"
            color var(--v-primary-base)

        td:nth-of-type(3):before
            content "% de Reajuste:"
            color var(--v-primary-base)

        td:nth-of-type(4):before
            content "Valor Base:"
            color var(--v-primary-base)

        td:nth-of-type(5):before
            content "Indicador:"
            color var(--v-primary-base)

        td:nth-of-type(6):before
            content "Valor Atualizado:"
            color var(--v-primary-base)

        td:last-child:before
            content "Ações:"
            color var(--v-primary-base)
</style>